import { Modal } from '@components/Modal'
import { YStack } from 'tamagui'
import { TopicForm } from './TopicForm'

type ToastType = 'success' | 'error'

interface ICommentModalProps {
  open: boolean
  onClose: () => void
  courseContentId: string
  onCreated?: () => void
  onToast?: (type: ToastType, message: string) => void
}

export function CommentModal({
  open,
  onClose,
  courseContentId,
  onCreated,
  onToast,
}: ICommentModalProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      snapPoints={[35]}
      snapPointsMode="percent"
      dismissOnOverlayPress
    >
      <YStack
        gap="$spacing-inset-sm"
        p="$spacing-inset-md"
        testID="comment-modal"
      >
        <TopicForm
          courseContentId={courseContentId}
          onToast={onToast}
          onCreated={() => {
            onCreated?.()
            onClose()
          }}
        />
      </YStack>
    </Modal>
  )
}
